module.exports = {
  "chat.end":"Redémarrez votre conversation de chat",
  "chat.endall":"Mettre fin à la discussion",
  "chat.cancel":"Annuler",
  "chat.cookie":"Cet assistant numérique utilise des cookies pour vous garantir la meilleure expérience",
  "chat.learn":"Apprendre encore plus",
  "chat.minimize":"Minimiser",
  "chat.hide":"proche",
  "chat.hidebot.text":"Fermer fera disparaître l'avatar pendant 15 minutes",
  "chat.hidebot":"Fermer le robot",
  "chat.restart":"Redémarrer",
  "switch.language":"Changer de langue",
  "switch.property":"Changer de propriété",
  "restart.converstation":"Redémarrer la conversation",
  "chat.endtext":"Voulez-vous vraiment mettre fin au chat en cours ?",
  "check.availabity":"Consultar disponibilidad",
  "check.availabity.submit":"Enviar",
  "check.availabity.cancel":"Annuler",
  "check.availabity.adults":"Adultes ",
  "check.availabity.children":"Enfants",
  "check.availabity.child.age":"Âge - Enfant",
  "feedback.leave":"Laisser les commentaires",
  "feedback.leave.message":"Laissez un message",
    "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email" :" Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode":"Zip Code"
};
